import type { FormError, FormResponse } from "../types/form-response";

function isSuccessResponse<T>(
  response: FormResponse<T>,
): response is { success: true; data: T } {
  return response.success;
}

function isErrorResponse<T>(
  response: FormResponse<T>,
): response is { success: false; error: FormError } {
  return !response.success;
}

function createSuccessResponse<T>(data: T): FormResponse<T> {
  return { data, success: true };
}

function createErrorResponse<T>(error: FormError): FormResponse<T> {
  return { error, success: false };
}

export {
  createErrorResponse,
  createSuccessResponse,
  isErrorResponse,
  isSuccessResponse,
};
